import { Component, OnInit, Input, EventEmitter, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validators, FormArray } from '@angular/forms';
import { GlobalServices } from 'src/app/shared/services/global.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from 'src/app/front-user/shared/services/authentication.service';
import { AlertService } from 'src/app/shared/components/alert/alert.service';
import { User } from 'src/app/front-user/shared/models/user.model';
import { BaseRequest } from 'src/app/shared/models/base-request.model';
import { ResponseObject } from 'src/app/shared/models/response-object.model';
import { Languages, FormMode, ServiceStatus, SUMeasurementDecision } from 'src/app/shared/models/enums.model';
import { TranslateService } from '@ngx-translate/core';
import { SmallUnitadminDTO } from '../shared/models/small-units-admin.model';
import { SmallUnitsAdminService } from '../shared/services/small-units.service.admin';
import { SmallUnitRequest } from 'src/app/front-user/services/small-units/shared/models/Small-Unit-Request.model';
import { EntranceRequestComponent } from 'src/app/front-user/services/small-units/entrance-request/entrance-request.component';
import { SmallUnitsServiceFE } from 'src/app/front-user/services/small-units/shared/services/small-units.service';
import { first } from 'rxjs/operators';
import { SmallUnitService } from '../shared/models/small-units-service.model';
import { CustomValidators } from 'src/app/front-user/shipyard-service/models/custom-validator';
//import { Key } from 'protractor';

@Component({
  selector: 'app-final-fees',
  templateUrl: './final-fees-component.html'
})

export class FinalFeesComponent implements OnInit {
  submitted = false;
  loading = false;
  baseRequestId: string = '';
  requestStatus: number;
  baseRequestDTO: BaseRequest //= new BaseRequest();
  displayedLang: string;
  public finalFeesForm: FormGroup;
  user: User = new User();
  showRequest = false;
  finalFeesObject: SmallUnitadminDTO = new SmallUnitadminDTO();
  smallUnitRequestDTO: SmallUnitRequest = new SmallUnitRequest();
  smallUnitServiceDTO: SmallUnitService = new SmallUnitService();
  agentId: string;
  responseObj: ResponseObject = new ResponseObject();
  public FormMode: any = FormMode;
  public formMode: any = FormMode.Add;
  isLoaded: boolean = false;
  numberRegex: string = '^[0-9]+(\\.?[0-9]+)?$';
  addedSmallUnitServices = [];
  @Input() public isShow: boolean = true;
  @ViewChild('EntranceRequest',{static: false}) EntranceRequest: EntranceRequestComponent;
  public disableForm: boolean = false;
  isErrorMessage: boolean = false;
  lockTaskErrorMessage: boolean = false;
  actualNetTonnage: number;
  totalServicesValue: number = 0;
  todayDate= new Date();
  constructor(private formBuilder: FormBuilder,
    private globalSrv: GlobalServices,
    private route: ActivatedRoute, private router: Router,
    private authenticationService: AuthenticationService, private alertService: AlertService,
    private translate: TranslateService,
    private suServ: SmallUnitsServiceFE, private suAdminServ: SmallUnitsAdminService) {
    this.isShow = true;
    if (history.state.data && history.state.data.requestId) {
      this.baseRequestId = history.state.data.requestId;
      this.getBaseRequest();
    } else {
      window.history.back();
    }
    this.displayedLang = this.globalSrv.getLanguage() == Languages.Arabic ? 'NameAR' : 'NameEN';
    this.user = this.globalSrv.user;

  }

  ngOnInit(): void {
    this.buildForm();
  }
  buildForm() {
    this.finalFeesForm = this.formBuilder.group({
      FinalSDR: ['', [Validators.required, Validators.pattern(this.numberRegex)]],
      LocalEquiv: ['', [Validators.required, Validators.pattern(this.numberRegex)]],
      FinalTransitFeesValue: ['0', [Validators.required, Validators.pattern(this.numberRegex)]],
      FinalTotalFees: ['0', [Validators.required, Validators.pattern(this.numberRegex)]],
      FinalTotalFeesLE: ['0', [Validators.required, Validators.pattern(this.numberRegex)]],
      InvoiceNo:['', Validators.required],
      SmallUnitServices: this.formBuilder.array([])
    });
  }
  get f() {
    return this.finalFeesForm.controls;
  }
  loadfinalfees(){
    this.buildForm();
    this.patchvalues();
  }
  patchvalues(){
    this.finalFeesForm.patchValue({
      FinalSDR: this.smallUnitRequestDTO.FinalSDR,
      FinalTransitFeesValue: this.smallUnitRequestDTO.FinalTransitFeesValue,
      FinalTotalFees: this.smallUnitRequestDTO.FinalTotalFees,
      LocalEquiv: this.smallUnitRequestDTO.LocalEquiv,
      FinalTotalFeesLE: this.smallUnitRequestDTO.TotalFeesLE,
      InvoiceNo: this.smallUnitRequestDTO.InvoiceNo
    });
    this.finalFeesForm.setControl('SmallUnitServices', this.bindSUServices(this.smallUnitRequestDTO.SmallUnitServices));
  }
  getBaseRequest() {
    this.suServ.get(this.baseRequestId).pipe(first()).subscribe(
      (resObj: ResponseObject) => {
        this.responseObj = resObj;
        if (this.responseObj.Success) {
          this.smallUnitRequestDTO = this.responseObj.Data;
          this.requestStatus = this.smallUnitRequestDTO.StatusId;
          this.agentId = this.smallUnitRequestDTO.RequestorId;
          this.actualNetTonnage = this.smallUnitRequestDTO.ActualSCNT;
          this.isLoaded = true;
          // check if component open fron request history
          if (history.state.data && history.state.data.isCompleted) {

            this.formMode = FormMode.Readonly;
            this.loadfinalfees();
            this.finalFeesForm.disable();
            /* this.buildForm();
            this.finalFeesForm.patchValue({
              FinalSDR: this.smallUnitRequestDTO.FinalSDR,
              FinalTransitFeesValue: this.smallUnitRequestDTO.FinalTransitFeesValue,
              FinalTotalFees: this.smallUnitRequestDTO.FinalTotalFees,
              LocalEquiv: this.smallUnitRequestDTO.LocalEquiv,
              FinalTotalFeesLE: this.smallUnitRequestDTO.TotalFeesLE,
              InvoiceNo: this.smallUnitRequestDTO.InvoiceNo
            });
            this.finalFeesForm.setControl('SmallUnitServices', this.bindSUServices(this.smallUnitRequestDTO.SmallUnitServices)); */

          } else if ((this.requestStatus == ServiceStatus.SmallUnit_ISMTransitConfirmed_PendingFinalFees
            || this.requestStatus == ServiceStatus.SmallUnit_ISMTransitPostponed_PendingFinalFees
            || this.requestStatus == ServiceStatus.SmallUnit_ISMUnitArrivalCancelled_PendingFinalFees
            || this.requestStatus == ServiceStatus.SmallUnit_ISMUnitArrivalConfirmed_PendingFinalFees
            || this.requestStatus == ServiceStatus.SmallUnit_PendingISMDepartureApproval_PendingFinalFees
            || this.requestStatus == ServiceStatus.SmallUnit_PendingISMTransitConfirmation_PendingFinalFees
            || this.requestStatus == ServiceStatus.SmallUnit_PendingISMUnitArrival_PendingFinalFees
            || this.requestStatus == ServiceStatus.SmallUnit_PendingFinalFees
            || this.requestStatus == ServiceStatus.SmallUnit_PendingFinalFeesReview
          ) && this.smallUnitRequestDTO.FinalTotalFees == null) {
            this.formMode = FormMode.Add;
            this.finalFeesForm.enable();
            // this.AddSUservice();
          } else if ((this.requestStatus == ServiceStatus.SmallUnit_ISMTransitConfirmed_PendingFinalFees
              || this.requestStatus == ServiceStatus.SmallUnit_ISMTransitPostponed_PendingFinalFees
              || this.requestStatus == ServiceStatus.SmallUnit_ISMUnitArrivalCancelled_PendingFinalFees
              || this.requestStatus == ServiceStatus.SmallUnit_ISMUnitArrivalConfirmed_PendingFinalFees
              || this.requestStatus == ServiceStatus.SmallUnit_PendingISMDepartureApproval_PendingFinalFees
              || this.requestStatus == ServiceStatus.SmallUnit_PendingISMTransitConfirmation_PendingFinalFees
              || this.requestStatus == ServiceStatus.SmallUnit_PendingISMUnitArrival_PendingFinalFees
              || this.requestStatus == ServiceStatus.SmallUnit_PendingFinalFees
              || this.requestStatus == ServiceStatus.SmallUnit_PendingFinalFeesReview
            ) && this.smallUnitRequestDTO.FinalTotalFees != null) {
            // to hide submit button
            this.finalFeesObject.IsFinalFeesReview = this.smallUnitRequestDTO.InvoiceNo !== null && this.smallUnitRequestDTO.InvoiceNo != "" ? true : false;
            this.formMode = FormMode.Add;
            this.loadfinalfees();
            this.finalFeesForm.enable();
            this.finalFeesForm.controls['SmallUnitServices'].enable();
          } else {
            // to hide submit button
            this.formMode = FormMode.Readonly;
            this.finalFeesForm.disable();
            this.patchvalues();
          }

        }
      }

    )
  }
  bindSUServices(SmallUnitServices) {
    let control = <FormArray>this.finalFeesForm.controls['SmallUnitServices'];
    SmallUnitServices.forEach((key) => {
      let ServiceName = new FormControl({ value: key.ServiceName, disabled: true });
      let ServiceValue = new FormControl({ value: key.ServiceValue, disabled: true });
      let ServiceDate = new FormControl({ value: new Date(key.ServiceDate), disabled: true });
      let ServiceTime = new FormControl({ value: new Date(key.ServiceDate), disabled: true });
      let ServiceDayNight = new FormControl({ value: key.ServiceDayNight, disabled: true });
      let ServiceDesc = new FormControl({ value: key.ServiceDesc, disabled: true });
      let formGroup = new FormGroup({
        ServiceName,
        ServiceValue,
        ServiceDate,
        ServiceTime,
        ServiceDayNight,
        ServiceDesc
      });
      control.push(formGroup);
    });
    return control;
  }
  AddSUservice() {
    let control = <FormArray>this.finalFeesForm.controls['SmallUnitServices'];
    control.push(new FormGroup({
      ServiceName: new FormControl('', Validators.required),
      ServiceDate: new FormControl('', Validators.required),
      ServiceTime: new FormControl(new Date(), Validators.required),
      ServiceDateTime: new FormControl(''),
      ServiceDayNight: new FormControl(''),
      ServiceDesc: new FormControl('',  Validators.maxLength(200)),
      ServiceValue: new FormControl('', [Validators.required, Validators.pattern(this.numberRegex)]),
    }));
  }
  get SUServices() {
    return this.finalFeesForm.get("SmallUnitServices") as FormArray;
  }
  DeleteSUservice(index: number) {
    this.SUServices.removeAt(index);
    this.serviceValueChanged();
  }
  finalSDRChanged(event) {
    if (this.finalFeesForm.controls.FinalSDR.valid) {
      let finalSDRRate = event.target.value;
      if (finalSDRRate != "") {
        let finalTransitFees = this.calculateFinalTransitFees(this.actualNetTonnage, finalSDRRate);
        this.finalFeesForm.patchValue({
          FinalTransitFeesValue: finalTransitFees,
          FinalTotalFees: this.totalServicesValue + Number(finalTransitFees)
        });
      }
    } else {
      this.finalFeesForm.patchValue({
        FinalTransitFeesValue: "0"
      });
    }
  }

  localEquivChanged(event) {
    if (this.finalFeesForm.controls.LocalEquiv.valid) {
      let LocalEquiv = event.target.value;
      if (LocalEquiv != "") {
        let FinalTotalFees_LE = (this.finalFeesForm.controls.FinalTotalFees.value * LocalEquiv);
        this.finalFeesForm.patchValue({
          FinalTotalFeesLE: FinalTotalFees_LE
        });
      }
    } else {
      this.finalFeesForm.patchValue({
        FinalTotalFeesLE: "0"
      });
    }
  }
  finalfeesChanged(){
    if (this.finalFeesForm.controls.LocalEquiv.valid) {
      let LocalEquiv = this.finalFeesForm.controls.LocalEquiv.value;
      if (LocalEquiv != "") {
        let FinalTotalFees_LE = (this.finalFeesForm.controls.FinalTotalFees.value * LocalEquiv);
        this.finalFeesForm.patchValue({
          FinalTotalFeesLE: FinalTotalFees_LE
        });
      }
    } else {
      this.finalFeesForm.patchValue({
        FinalTotalFeesLE: "0"
      });
    }
  }

  calculateFinalTransitFees(actualNetTonnage: any, finalSDRRate: any) {
    return (5 * actualNetTonnage * finalSDRRate).toFixed(2);
  }
  serviceValueChanged() {
    this.totalServicesValue = 0;
    this.SUServices.controls.forEach(element => {
      this.totalServicesValue += Number(element.value.ServiceValue);
    });
    this.finalFeesForm.patchValue({
      FinalTotalFees: this.totalServicesValue + Number(this.finalFeesForm.controls.FinalTransitFeesValue.value)
    });
  }
  onSubmit() {
    this.submitted = true;
    // stop here if form is invalid
    if (this.finalFeesForm.invalid) {
      return;
    }
    this.alertService.clear();
    this.globalSrv.isLoaderEnabled = true;
    this.loading = true;
    this.SUServices.controls.forEach(element => {
      this.smallUnitServiceDTO = new SmallUnitService();
      this.smallUnitServiceDTO.BaseRequestId = this.baseRequestId;
      this.smallUnitServiceDTO.ServiceName = element.value.ServiceName;
      if (element.value.ServiceDate) {
        var selectedDate = element.value.ServiceDate.toLocaleString('en-US', { year: "numeric", month: "numeric", day: "numeric" });
        var selectedTime = element.value.ServiceTime.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', second: 'numeric', hour12: true })
        var fullDate = selectedDate + ", " + selectedTime;
        // Concatenate (ServiceDate&&ServiceTime) as string before sending it to backend to avoid converting them to Greenwich time
        this.smallUnitServiceDTO.ServiceDate = fullDate; ;
      }
      this.smallUnitServiceDTO.ServiceDayNight = element.value.ServiceDayNight;
      this.smallUnitServiceDTO.ServiceValue = element.value.ServiceValue;
      this.smallUnitServiceDTO.ServiceDesc = element.value.ServiceDesc;
      this.addedSmallUnitServices.push(this.smallUnitServiceDTO);
    });
    this.finalFeesObject.SmallUnitServicesDTO = this.addedSmallUnitServices;
    this.finalFeesObject.AdminEmail = this.user.UserName;
    this.finalFeesObject.Id = this.baseRequestId;
    this.finalFeesObject.FinalSDR = this.finalFeesForm.controls.FinalSDR.value;
    this.finalFeesObject.FinalTransitFeesValue = this.finalFeesForm.controls.FinalTransitFeesValue.value;
    this.finalFeesObject.FinalTotalFees = this.finalFeesForm.controls.FinalTotalFees.value;
    this.finalFeesObject.LocalEquiv = this.finalFeesForm.controls.LocalEquiv.value;
    this.finalFeesObject.TotalFeesLE = this.finalFeesForm.controls.FinalTotalFeesLE.value;
    this.finalFeesObject.InvoiceNo = this.finalFeesForm.controls.InvoiceNo.value;
    this.finalFeesObject.InvoiceDate = new Date().toLocaleString('en-US');
    this.finalFeesObject.InvoiceAccountantName = this.user.FullName;


    this.suAdminServ.AddFinalFees(this.finalFeesObject)
      .subscribe(
        (data: ResponseObject) => {
          if (data.Success) {
            this.globalSrv.isLoaderEnabled = false;
            //this.alertService.success('Decision Submitted Successfully', false);
            this.finalFeesForm.reset();
            this.loading = false;
            this.showRequest = true;
            this.isErrorMessage = false;
          }
          else if (data.ErrorMessages.find(e => e == "TaskCompletedByAnotherUser") != null) {
            this.lockTaskErrorMessage = true;
            this.showRequest = true;
            this.globalSrv.isLoaderEnabled = false;
          }
          else {
            this.globalSrv.isLoaderEnabled = false;
            this.showRequest = true;
            this.isErrorMessage = true;
            //this.alertService.error(this.translate.instant('FRONT_USER.ERRORS_MESSAGES.'+data.ErrorMessages[0]), false);

            this.loading = false;
          }

        });
  }
}
